import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import ProfileStatItem from '../ProfileStatItem';
import ProfileHeadStats from '../ProfileHeadStats';
import { getIsGroupProfile } from '../../../../../selectors/users';
import s from './ProfileStats.scss';

interface Props {
  [stat: string]: number | string;
}

const ProfileStats: FC<Props> = ({ ...stats }) => {
  const isGroupProfile = useSelector(getIsGroupProfile);
  const showHeadStats = useFlag('profile_head_stats');

  if (showHeadStats && !isGroupProfile) {
    return <ProfileHeadStats stats={stats} />;
  }

  const showStats = isGroupProfile
    ? ['founded', 'members', 'watchers']
    : ['watchers', 'deviations', 'pageviews'];

  return (
    <div className={s['root']}>
      {showStats.map(stat => (
        <ProfileStatItem
          key={stat}
          stat={stat}
          value={stats[stat]}
          className={s['stats-item']}
          bold={isGroupProfile}
        />
      ))}
    </div>
  );
};

export default ProfileStats;
